import React from 'react';

import { IconType } from '../icon/types';
import { IconWithCoordinates } from '../youAreHerePin/IconWithCoordinates';
import styles from './LegTwoVisualStep.module.scss';

type LegTwoVisualStepPrintProps = {
  map: string | undefined;
  onMapLoad: (event: any) => void;
  showYouAreHere: boolean;
  startingPoint: { x: number; y: number };
  endingPoint: { x: number; y: number };
  isLastStep: boolean | undefined;
  svgPath: string;
  startArrowPath: string;
  endArrowPath: string;
  index: number;
  formattedInstruction: string;
  imgHeight: number;
  imgWidth: number;
};
export const LegTwoVisualStepPrint = React.forwardRef<
  HTMLImageElement,
  LegTwoVisualStepPrintProps
>(
  (
    {
      map,
      onMapLoad,
      showYouAreHere,
      startingPoint,
      endingPoint,
      isLastStep,
      svgPath,
      startArrowPath,
      endArrowPath,
      index,
      formattedInstruction,
      imgHeight,
      imgWidth,
    },
    ref,
  ) => (
    <div className={styles.stepContainerPrint}>
      <div className={styles.mapImageWrapper}>
        {/* TODO: May want to implement a loading state here since the campus map image is large */}
        <img
          className={`${styles.mapWebImg} ${styles.mapPrint}`}
          src={map}
          ref={ref}
          onLoad={onMapLoad}
          alt={'stepDirections'}
        />
        {showYouAreHere && (
          <IconWithCoordinates
            coordinates={startingPoint}
            iconType={IconType.YOU_ARE_HERE}
            size={125}
          />
        )}
        {isLastStep && (
          <IconWithCoordinates
            coordinates={endingPoint}
            iconType={IconType.PIN_ACTIVE}
            size={50}
          />
        )}
        <svg className={styles.overlay} height={imgHeight} width={imgWidth}>
          {!showYouAreHere && (
            <circle
              cx={startingPoint.x}
              cy={startingPoint.y}
              r="10"
              fill="white"
              stroke="black"
              strokeWidth="4"
            />
          )}
          {!isLastStep && (
            <circle
              cx={endingPoint.x}
              cy={endingPoint.y}
              r="10"
              fill="#0D6AFF"
              stroke="#0D6AFF"
              strokeWidth="4"
            />
          )}
          <path
            id="any"
            d={svgPath}
            stroke="#0D6AFF"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="8 8"
            strokeMiterlimit="6.67"
            fill="none"
          />
        </svg>
      </div>
      <div className={styles.printStepFooter}>
        <div className={styles.printStepNumber}>
          <div className={styles.printStepNumberText}>{index + 1}.</div>
        </div>
        <h2 className={styles.instruction}>{formattedInstruction}</h2>
      </div>
    </div>
  ),
);
